import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios';
import {post,get} from './http';
// import Print from 'vue-print-nb'
import Print from './plugs/print'

Vue.use(Element)
Vue.use(Vant);
Vue.use(Print);
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$post = post
Vue.prototype.$get = get

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
